import ProfileForm from "../../../components/ProfileComponents/ProfileForm";
import { useEffect, useState } from "react";
import { UserEdit } from "../../../models/UsersInfo";
import { useSessionData } from "../../../Contexts/SessionDataContext";
import { fetchUserDataEdition, fetchLanguagesAvailables } from "../../../api/repositoryEP";
import { LoadingOutlined } from "@ant-design/icons";
import './ProfilePage.scss';

const ProfilePage = (): JSX.Element => {

    const userId = useSessionData().sessionData.userData.id;
    const [userData, setUserData] = useState<UserEdit | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [languages, setLanguages] = useState<string[]>([]);

    useEffect(() => {
        setLoading(true);
        fetchUserDataEdition(userId).then((data) => {
            setUserData(data?.data);
            setLoading(false);
        });
    }, [userId]);

    useEffect(() => {
        fetchLanguagesAvailables("bo").then((response) => {
            if (response && response?.type == 1 && response?.data) {
                const languages = response.data;
                setLanguages(languages);
            }
        });
    }, []);

    return (
        <div className="profile-page">
            {loading ? (
                <div className="loading-container">
                    <LoadingOutlined style={{ fontSize: 48 }} />
                </div>
            ) : (
                <ProfileForm languages={languages} userData={userData} setUserData={setUserData} />
            )}
        </div>
    );
};

export default ProfilePage;
